import { lazy, Suspense } from 'react';
import { LoaderFullPage } from './components';

const NewUICustomerQuestionnaire = lazy(
	() => import('./new-ui-customer-questionnaire/App').then((module) => ({ default: module.NewUICustomerQuestionnaire }))
);

export const ABTestNewUICustomerQuestionnaire = () => {
	return (
		<Suspense fallback={<LoaderFullPage />}>
			<NewUICustomerQuestionnaire />
		</Suspense>
	);
};
